/* istanbul ignore file */
import React, { useMemo } from 'react';
import { useShowContext } from 'framework/show';
import { useLeadId } from 'domain/sales/lead/leadRouting';
import LeadsBreadcrumbs from 'domain/sales/lead/shared/LeadsBreadcrumbs';
import { useLeadUrl } from 'domain/shared/lead';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';

/**
 * Returns lead create pages breadcrumbs.
 * @returns {*}
 * @constructor
 */
const SingleLeadBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const firstName = data.getValueBySource('firstName');
  const lastName = data.getValueBySource('lastName');
  const middleName = data.getValueBySource('middleName');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const displayedName = useMemo(() => `${firstName} ${middleName} ${lastName}`, []);

  const { getSingleEntityUrl } = useLeadUrl();
  const id = useLeadId();

  return (
    <LeadsBreadcrumbs>
      <SingleBreadcrumbItem entity={displayedName} link={getSingleEntityUrl(id)} />
      {children}
    </LeadsBreadcrumbs>
  );
};

export default SingleLeadBreadcrumbs;
